import { Component, ViewChild, Input } from '@angular/core';
import {
  FormComponent as _FormComponent,
  ActionRegistry,
  FormPropertyFactory,
  SchemaPreprocessor,
  ValidatorRegistry,
  SchemaValidatorFactory,
  WidgetFactory,
  TerminatorService,
} from './angular2-schema-form-shim';

import { JSONSchema, FormElementToast } from './types/json-schema';
import { SPSchemaValidatorFactory } from './schemavalidatorfactory';
import { SPFormPropertyFactory, useFactory } from './formpropertyfactory';
import { FormElementComponent } from './formelement.component';

@Component( {
  selector: 'sp-form',
  templateUrl: './form.component.html',
  providers: [
    ActionRegistry,
    ValidatorRegistry,
    SchemaPreprocessor,
    WidgetFactory,
    {
      provide: SchemaValidatorFactory,
      useClass: SPSchemaValidatorFactory,
    },
    {
      provide: FormPropertyFactory,
      useFactory: useFactory,
      useClass: SPFormPropertyFactory,
      deps: [ SchemaValidatorFactory, ValidatorRegistry ],
    },
    TerminatorService,
  ],
} )
export class FormComponent extends _FormComponent {
  schema: JSONSchema;

  @Input()
  toast: FormElementToast = null

  @ViewChild( 'formElement' ) formElement: FormElementComponent;
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/form.component.ts